import { ChronicIllness } from '@aphp-ema/common/participant/chronicIllnesses';
import { TFunctionChronicIllnesses } from '@/core/i18n';

export const getDisplayName = (
  illness: ChronicIllness,
  t: TFunctionChronicIllnesses,
): string => {
  if (illness.type === 'predefined') {
    return t(illness.value);
  }
  return illness.value;
};
